import withHttp from '@/config/withHttp';
import eitsApi from './eitsApi';
/* *************** 庭审中相关接口 ******************* */

var apis = {
  // 获取挑战码
  CHALLENGE_CODE_SDK: {
    url: eitsApi.CHALLENGE_CODE_SDK,
    method: 'post'
  },
  // 获取人员信息
  GET_USER_INFO: {
    url: eitsApi.GET_USER_INFO,
    method: 'post'
  }
};
export default withHttp(apis);